import { render, staticRenderFns } from "./StudiInstructionForm.vue?vue&type=template&id=11c13878"
import script from "./StudiInstructionForm.vue?vue&type=script&lang=js"
export * from "./StudiInstructionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports